/* tslint:disable */
/* eslint-disable */
/**
 * Chaos API
 * This is a server of API to inject fault into tidb cluster.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI } from './base';
export const ApiActionKindEnum = {
    pod_shutdown: 'pod_shutdown'
};
export const ApiBackendStatusStatusEnum = {
    ready: 'ready',
    disabled: 'disabled',
    installing: 'installing',
    uninstalling: 'uninstalling',
    install_failed: 'install_failed'
};
export const ApiExperimentStatusEnum = {
    Waiting_Approve: 'Waiting Approve',
    Draft: 'Draft',
    Running: 'Running',
    Done: 'Done',
    Failed: 'Failed',
    Deleted: 'Deleted'
};
export const ApiTargetComponentEnum = {
    tidb: 'tidb',
    tikv: 'tikv',
    pd: 'pd'
};
export const ApiTargetModeEnum = {
    random: 'random',
    specified: 'specified'
};
/**
 * ChaosApi - axios parameter creator
 * @export
 */
export const ChaosApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * List experiment actions
         * @summary List experiment actions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chaosApiActionsSchemaGet: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/chaos/api/actions/schema`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Approve a draft chaos experiment
         * @summary Approve a draft chaos experiment
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} eid experiment id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chaosApiApproveOrgsOidClustersCidExperimentsEidPost: (oid_1, cid_1, eid_1, ...args_1) => __awaiter(this, [oid_1, cid_1, eid_1, ...args_1], void 0, function* (oid, cid, eid, options = {}) {
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('chaosApiApproveOrgsOidClustersCidExperimentsEidPost', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('chaosApiApproveOrgsOidClustersCidExperimentsEidPost', 'cid', cid);
            // verify required parameter 'eid' is not null or undefined
            assertParamExists('chaosApiApproveOrgsOidClustersCidExperimentsEidPost', 'eid', eid);
            const localVarPath = `/chaos/api/approve/orgs/{oid}/clusters/{cid}/experiments/{eid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)))
                .replace(`{${"eid"}}`, encodeURIComponent(String(eid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * List components
         * @summary List components
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chaosApiComponentsOrgsOidClustersCidGet: (oid_1, cid_1, ...args_1) => __awaiter(this, [oid_1, cid_1, ...args_1], void 0, function* (oid, cid, options = {}) {
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('chaosApiComponentsOrgsOidClustersCidGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('chaosApiComponentsOrgsOidClustersCidGet', 'cid', cid);
            const localVarPath = `/chaos/api/components/orgs/{oid}/clusters/{cid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create draft chaos experiment
         * @summary Create draft chaos experiment
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {ApiCreateExperimentRequest} experiment create draft experiment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chaosApiDraftOrgsOidClustersCidPost: (oid_1, cid_1, experiment_1, ...args_1) => __awaiter(this, [oid_1, cid_1, experiment_1, ...args_1], void 0, function* (oid, cid, experiment, options = {}) {
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('chaosApiDraftOrgsOidClustersCidPost', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('chaosApiDraftOrgsOidClustersCidPost', 'cid', cid);
            // verify required parameter 'experiment' is not null or undefined
            assertParamExists('chaosApiDraftOrgsOidClustersCidPost', 'experiment', experiment);
            const localVarPath = `/chaos/api/draft/orgs/{oid}/clusters/{cid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(experiment, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete chaos experiment
         * @summary Delete chaos experiment
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} eid experiment id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chaosApiOrgsOidClustersCidExperimentsEidDelete: (oid_1, cid_1, eid_1, ...args_1) => __awaiter(this, [oid_1, cid_1, eid_1, ...args_1], void 0, function* (oid, cid, eid, options = {}) {
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('chaosApiOrgsOidClustersCidExperimentsEidDelete', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('chaosApiOrgsOidClustersCidExperimentsEidDelete', 'cid', cid);
            // verify required parameter 'eid' is not null or undefined
            assertParamExists('chaosApiOrgsOidClustersCidExperimentsEidDelete', 'eid', eid);
            const localVarPath = `/chaos/api/orgs/{oid}/clusters/{cid}/experiments/{eid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)))
                .replace(`{${"eid"}}`, encodeURIComponent(String(eid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get chaos experiment
         * @summary Get chaos experiment
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} eid experiment id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chaosApiOrgsOidClustersCidExperimentsEidGet: (oid_1, cid_1, eid_1, ...args_1) => __awaiter(this, [oid_1, cid_1, eid_1, ...args_1], void 0, function* (oid, cid, eid, options = {}) {
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('chaosApiOrgsOidClustersCidExperimentsEidGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('chaosApiOrgsOidClustersCidExperimentsEidGet', 'cid', cid);
            // verify required parameter 'eid' is not null or undefined
            assertParamExists('chaosApiOrgsOidClustersCidExperimentsEidGet', 'eid', eid);
            const localVarPath = `/chaos/api/orgs/{oid}/clusters/{cid}/experiments/{eid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)))
                .replace(`{${"eid"}}`, encodeURIComponent(String(eid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * List chaos experiments
         * @summary List chaos experiments
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} [page] the page index
         * @param {number} [size] the page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chaosApiOrgsOidClustersCidGet: (oid_1, cid_1, page_1, size_1, ...args_1) => __awaiter(this, [oid_1, cid_1, page_1, size_1, ...args_1], void 0, function* (oid, cid, page, size, options = {}) {
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('chaosApiOrgsOidClustersCidGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('chaosApiOrgsOidClustersCidGet', 'cid', cid);
            const localVarPath = `/chaos/api/orgs/{oid}/clusters/{cid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Start chaos experiment
         * @summary Start chaos experiment
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} eid experiment id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chaosApiStartOrgsOidClustersCidExperimentsEidPost: (oid_1, cid_1, eid_1, ...args_1) => __awaiter(this, [oid_1, cid_1, eid_1, ...args_1], void 0, function* (oid, cid, eid, options = {}) {
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('chaosApiStartOrgsOidClustersCidExperimentsEidPost', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('chaosApiStartOrgsOidClustersCidExperimentsEidPost', 'cid', cid);
            // verify required parameter 'eid' is not null or undefined
            assertParamExists('chaosApiStartOrgsOidClustersCidExperimentsEidPost', 'eid', eid);
            const localVarPath = `/chaos/api/start/orgs/{oid}/clusters/{cid}/experiments/{eid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)))
                .replace(`{${"eid"}}`, encodeURIComponent(String(eid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update experiment info
         * @summary Update experiment info
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} eid experiment id
         * @param {ApiExperimentInfo} info experiment info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chaosApiSummaryOrgsOidClustersCidExperimentsEidPost: (oid_1, cid_1, eid_1, info_1, ...args_1) => __awaiter(this, [oid_1, cid_1, eid_1, info_1, ...args_1], void 0, function* (oid, cid, eid, info, options = {}) {
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('chaosApiSummaryOrgsOidClustersCidExperimentsEidPost', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('chaosApiSummaryOrgsOidClustersCidExperimentsEidPost', 'cid', cid);
            // verify required parameter 'eid' is not null or undefined
            assertParamExists('chaosApiSummaryOrgsOidClustersCidExperimentsEidPost', 'eid', eid);
            // verify required parameter 'info' is not null or undefined
            assertParamExists('chaosApiSummaryOrgsOidClustersCidExperimentsEidPost', 'info', info);
            const localVarPath = `/chaos/api/summary/orgs/{oid}/clusters/{cid}/experiments/{eid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)))
                .replace(`{${"eid"}}`, encodeURIComponent(String(eid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(info, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Disable fault drill
         * @summary Disable fault drill
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faultApiOrgsOidClustersCidDelete: (oid_1, cid_1, ...args_1) => __awaiter(this, [oid_1, cid_1, ...args_1], void 0, function* (oid, cid, options = {}) {
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('faultApiOrgsOidClustersCidDelete', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('faultApiOrgsOidClustersCidDelete', 'cid', cid);
            const localVarPath = `/fault/api/orgs/{oid}/clusters/{cid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get fault drill backend status
         * @summary Get fault drill backend status
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faultApiOrgsOidClustersCidGet: (oid_1, cid_1, ...args_1) => __awaiter(this, [oid_1, cid_1, ...args_1], void 0, function* (oid, cid, options = {}) {
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('faultApiOrgsOidClustersCidGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('faultApiOrgsOidClustersCidGet', 'cid', cid);
            const localVarPath = `/fault/api/orgs/{oid}/clusters/{cid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Enable fault drill
         * @summary Enable fault drill
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faultApiOrgsOidClustersCidPost: (oid_1, cid_1, ...args_1) => __awaiter(this, [oid_1, cid_1, ...args_1], void 0, function* (oid, cid, options = {}) {
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('faultApiOrgsOidClustersCidPost', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('faultApiOrgsOidClustersCidPost', 'cid', cid);
            const localVarPath = `/fault/api/orgs/{oid}/clusters/{cid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Ping chaos backend
         * @summary Ping chaos backend
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faultApiPingGet: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/fault/api/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ChaosApi - functional programming interface
 * @export
 */
export const ChaosApiFp = function (configuration) {
    const localVarAxiosParamCreator = ChaosApiAxiosParamCreator(configuration);
    return {
        /**
         * List experiment actions
         * @summary List experiment actions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chaosApiActionsSchemaGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.chaosApiActionsSchemaGet(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Approve a draft chaos experiment
         * @summary Approve a draft chaos experiment
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} eid experiment id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chaosApiApproveOrgsOidClustersCidExperimentsEidPost(oid, cid, eid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.chaosApiApproveOrgsOidClustersCidExperimentsEidPost(oid, cid, eid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * List components
         * @summary List components
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chaosApiComponentsOrgsOidClustersCidGet(oid, cid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.chaosApiComponentsOrgsOidClustersCidGet(oid, cid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Create draft chaos experiment
         * @summary Create draft chaos experiment
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {ApiCreateExperimentRequest} experiment create draft experiment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chaosApiDraftOrgsOidClustersCidPost(oid, cid, experiment, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.chaosApiDraftOrgsOidClustersCidPost(oid, cid, experiment, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Delete chaos experiment
         * @summary Delete chaos experiment
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} eid experiment id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chaosApiOrgsOidClustersCidExperimentsEidDelete(oid, cid, eid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.chaosApiOrgsOidClustersCidExperimentsEidDelete(oid, cid, eid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Get chaos experiment
         * @summary Get chaos experiment
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} eid experiment id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chaosApiOrgsOidClustersCidExperimentsEidGet(oid, cid, eid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.chaosApiOrgsOidClustersCidExperimentsEidGet(oid, cid, eid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * List chaos experiments
         * @summary List chaos experiments
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} [page] the page index
         * @param {number} [size] the page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chaosApiOrgsOidClustersCidGet(oid, cid, page, size, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.chaosApiOrgsOidClustersCidGet(oid, cid, page, size, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Start chaos experiment
         * @summary Start chaos experiment
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} eid experiment id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chaosApiStartOrgsOidClustersCidExperimentsEidPost(oid, cid, eid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.chaosApiStartOrgsOidClustersCidExperimentsEidPost(oid, cid, eid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Update experiment info
         * @summary Update experiment info
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} eid experiment id
         * @param {ApiExperimentInfo} info experiment info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chaosApiSummaryOrgsOidClustersCidExperimentsEidPost(oid, cid, eid, info, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.chaosApiSummaryOrgsOidClustersCidExperimentsEidPost(oid, cid, eid, info, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Disable fault drill
         * @summary Disable fault drill
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faultApiOrgsOidClustersCidDelete(oid, cid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.faultApiOrgsOidClustersCidDelete(oid, cid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Get fault drill backend status
         * @summary Get fault drill backend status
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faultApiOrgsOidClustersCidGet(oid, cid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.faultApiOrgsOidClustersCidGet(oid, cid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Enable fault drill
         * @summary Enable fault drill
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faultApiOrgsOidClustersCidPost(oid, cid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.faultApiOrgsOidClustersCidPost(oid, cid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Ping chaos backend
         * @summary Ping chaos backend
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faultApiPingGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.faultApiPingGet(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ChaosApi - factory interface
 * @export
 */
export const ChaosApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ChaosApiFp(configuration);
    return {
        /**
         * List experiment actions
         * @summary List experiment actions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chaosApiActionsSchemaGet(options) {
            return localVarFp.chaosApiActionsSchemaGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Approve a draft chaos experiment
         * @summary Approve a draft chaos experiment
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} eid experiment id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chaosApiApproveOrgsOidClustersCidExperimentsEidPost(oid, cid, eid, options) {
            return localVarFp.chaosApiApproveOrgsOidClustersCidExperimentsEidPost(oid, cid, eid, options).then((request) => request(axios, basePath));
        },
        /**
         * List components
         * @summary List components
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chaosApiComponentsOrgsOidClustersCidGet(oid, cid, options) {
            return localVarFp.chaosApiComponentsOrgsOidClustersCidGet(oid, cid, options).then((request) => request(axios, basePath));
        },
        /**
         * Create draft chaos experiment
         * @summary Create draft chaos experiment
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {ApiCreateExperimentRequest} experiment create draft experiment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chaosApiDraftOrgsOidClustersCidPost(oid, cid, experiment, options) {
            return localVarFp.chaosApiDraftOrgsOidClustersCidPost(oid, cid, experiment, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete chaos experiment
         * @summary Delete chaos experiment
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} eid experiment id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chaosApiOrgsOidClustersCidExperimentsEidDelete(oid, cid, eid, options) {
            return localVarFp.chaosApiOrgsOidClustersCidExperimentsEidDelete(oid, cid, eid, options).then((request) => request(axios, basePath));
        },
        /**
         * Get chaos experiment
         * @summary Get chaos experiment
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} eid experiment id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chaosApiOrgsOidClustersCidExperimentsEidGet(oid, cid, eid, options) {
            return localVarFp.chaosApiOrgsOidClustersCidExperimentsEidGet(oid, cid, eid, options).then((request) => request(axios, basePath));
        },
        /**
         * List chaos experiments
         * @summary List chaos experiments
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} [page] the page index
         * @param {number} [size] the page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chaosApiOrgsOidClustersCidGet(oid, cid, page, size, options) {
            return localVarFp.chaosApiOrgsOidClustersCidGet(oid, cid, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Start chaos experiment
         * @summary Start chaos experiment
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} eid experiment id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chaosApiStartOrgsOidClustersCidExperimentsEidPost(oid, cid, eid, options) {
            return localVarFp.chaosApiStartOrgsOidClustersCidExperimentsEidPost(oid, cid, eid, options).then((request) => request(axios, basePath));
        },
        /**
         * Update experiment info
         * @summary Update experiment info
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} eid experiment id
         * @param {ApiExperimentInfo} info experiment info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chaosApiSummaryOrgsOidClustersCidExperimentsEidPost(oid, cid, eid, info, options) {
            return localVarFp.chaosApiSummaryOrgsOidClustersCidExperimentsEidPost(oid, cid, eid, info, options).then((request) => request(axios, basePath));
        },
        /**
         * Disable fault drill
         * @summary Disable fault drill
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faultApiOrgsOidClustersCidDelete(oid, cid, options) {
            return localVarFp.faultApiOrgsOidClustersCidDelete(oid, cid, options).then((request) => request(axios, basePath));
        },
        /**
         * Get fault drill backend status
         * @summary Get fault drill backend status
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faultApiOrgsOidClustersCidGet(oid, cid, options) {
            return localVarFp.faultApiOrgsOidClustersCidGet(oid, cid, options).then((request) => request(axios, basePath));
        },
        /**
         * Enable fault drill
         * @summary Enable fault drill
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faultApiOrgsOidClustersCidPost(oid, cid, options) {
            return localVarFp.faultApiOrgsOidClustersCidPost(oid, cid, options).then((request) => request(axios, basePath));
        },
        /**
         * Ping chaos backend
         * @summary Ping chaos backend
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faultApiPingGet(options) {
            return localVarFp.faultApiPingGet(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ChaosApi - object-oriented interface
 * @export
 * @class ChaosApi
 * @extends {BaseAPI}
 */
export class ChaosApi extends BaseAPI {
    /**
     * List experiment actions
     * @summary List experiment actions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChaosApi
     */
    chaosApiActionsSchemaGet(options) {
        return ChaosApiFp(this.configuration).chaosApiActionsSchemaGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Approve a draft chaos experiment
     * @summary Approve a draft chaos experiment
     * @param {ChaosApiChaosApiApproveOrgsOidClustersCidExperimentsEidPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChaosApi
     */
    chaosApiApproveOrgsOidClustersCidExperimentsEidPost(requestParameters, options) {
        return ChaosApiFp(this.configuration).chaosApiApproveOrgsOidClustersCidExperimentsEidPost(requestParameters.oid, requestParameters.cid, requestParameters.eid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * List components
     * @summary List components
     * @param {ChaosApiChaosApiComponentsOrgsOidClustersCidGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChaosApi
     */
    chaosApiComponentsOrgsOidClustersCidGet(requestParameters, options) {
        return ChaosApiFp(this.configuration).chaosApiComponentsOrgsOidClustersCidGet(requestParameters.oid, requestParameters.cid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create draft chaos experiment
     * @summary Create draft chaos experiment
     * @param {ChaosApiChaosApiDraftOrgsOidClustersCidPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChaosApi
     */
    chaosApiDraftOrgsOidClustersCidPost(requestParameters, options) {
        return ChaosApiFp(this.configuration).chaosApiDraftOrgsOidClustersCidPost(requestParameters.oid, requestParameters.cid, requestParameters.experiment, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete chaos experiment
     * @summary Delete chaos experiment
     * @param {ChaosApiChaosApiOrgsOidClustersCidExperimentsEidDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChaosApi
     */
    chaosApiOrgsOidClustersCidExperimentsEidDelete(requestParameters, options) {
        return ChaosApiFp(this.configuration).chaosApiOrgsOidClustersCidExperimentsEidDelete(requestParameters.oid, requestParameters.cid, requestParameters.eid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get chaos experiment
     * @summary Get chaos experiment
     * @param {ChaosApiChaosApiOrgsOidClustersCidExperimentsEidGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChaosApi
     */
    chaosApiOrgsOidClustersCidExperimentsEidGet(requestParameters, options) {
        return ChaosApiFp(this.configuration).chaosApiOrgsOidClustersCidExperimentsEidGet(requestParameters.oid, requestParameters.cid, requestParameters.eid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * List chaos experiments
     * @summary List chaos experiments
     * @param {ChaosApiChaosApiOrgsOidClustersCidGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChaosApi
     */
    chaosApiOrgsOidClustersCidGet(requestParameters, options) {
        return ChaosApiFp(this.configuration).chaosApiOrgsOidClustersCidGet(requestParameters.oid, requestParameters.cid, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Start chaos experiment
     * @summary Start chaos experiment
     * @param {ChaosApiChaosApiStartOrgsOidClustersCidExperimentsEidPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChaosApi
     */
    chaosApiStartOrgsOidClustersCidExperimentsEidPost(requestParameters, options) {
        return ChaosApiFp(this.configuration).chaosApiStartOrgsOidClustersCidExperimentsEidPost(requestParameters.oid, requestParameters.cid, requestParameters.eid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update experiment info
     * @summary Update experiment info
     * @param {ChaosApiChaosApiSummaryOrgsOidClustersCidExperimentsEidPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChaosApi
     */
    chaosApiSummaryOrgsOidClustersCidExperimentsEidPost(requestParameters, options) {
        return ChaosApiFp(this.configuration).chaosApiSummaryOrgsOidClustersCidExperimentsEidPost(requestParameters.oid, requestParameters.cid, requestParameters.eid, requestParameters.info, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Disable fault drill
     * @summary Disable fault drill
     * @param {ChaosApiFaultApiOrgsOidClustersCidDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChaosApi
     */
    faultApiOrgsOidClustersCidDelete(requestParameters, options) {
        return ChaosApiFp(this.configuration).faultApiOrgsOidClustersCidDelete(requestParameters.oid, requestParameters.cid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get fault drill backend status
     * @summary Get fault drill backend status
     * @param {ChaosApiFaultApiOrgsOidClustersCidGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChaosApi
     */
    faultApiOrgsOidClustersCidGet(requestParameters, options) {
        return ChaosApiFp(this.configuration).faultApiOrgsOidClustersCidGet(requestParameters.oid, requestParameters.cid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Enable fault drill
     * @summary Enable fault drill
     * @param {ChaosApiFaultApiOrgsOidClustersCidPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChaosApi
     */
    faultApiOrgsOidClustersCidPost(requestParameters, options) {
        return ChaosApiFp(this.configuration).faultApiOrgsOidClustersCidPost(requestParameters.oid, requestParameters.cid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Ping chaos backend
     * @summary Ping chaos backend
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChaosApi
     */
    faultApiPingGet(options) {
        return ChaosApiFp(this.configuration).faultApiPingGet(options).then((request) => request(this.axios, this.basePath));
    }
}
